import React from 'react';
import { type Request } from '../../../shared/types';
import { formatCurrency, getTypeColors, getTypeLabels } from '../../../shared/utils';

interface RequestCardProps {
  request: Request;
  onApprove: (id: string | number) => void;
  onReject: (id: string | number) => void;
}

export const RequestCard: React.FC<RequestCardProps> = ({ request, onApprove, onReject }) => {
  const initials = request.producer
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase();

  return (
    <div className="border border-border rounded-lg p-4 hover:shadow-md transition">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center text-primary font-medium">
            {initials}
          </div>
          <div>
            <h3 className="font-medium">{request.producer}</h3>
            <p className="text-xs text-muted-foreground">Productor #{request.producerId}</p>
          </div>
        </div>
        <span className={`px-2 py-1 text-xs ${getTypeColors(request.type)} rounded-full font-medium`}>
          {getTypeLabels(request.type)}
        </span>
      </div>
      
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Monto:</span>
          <span className="font-medium">{formatCurrency(request.amount)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Fecha:</span>
          <span className="font-medium">{request.date}</span>
        </div>
      </div>
      
      <div className="flex gap-2 mt-4">
        <button 
          onClick={() => onApprove(request.id)}
          className="flex-1 px-3 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition"
        >
          Aprobar
        </button>
        <button 
          onClick={() => onReject(request.id)}
          className="flex-1 px-3 py-2 border border-border rounded-lg text-sm font-medium hover:bg-secondary transition"
        >
          Rechazar
        </button>
      </div>
    </div>
  );
};
